// extracted by mini-css-extract-plugin
module.exports = {"records":"styles_records__2bp01","title":"styles_title__1bFQV","alignRight":"styles_alignRight__Syuxn","actionButtons":"styles_actionButtons__35-9q","row":"styles_row__24ZDJ"};